import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { Exchange1031ViewModel } from '../shared/models/Exchange1031ViewModel';
import { Trade1031Service } from '../shared/providers/Trade1031.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { ValidationService } from '../shared/providers/validation.service';
import { AuthenticationService } from '../shared/auth/authentication.service'

@Component({
    selector: 'exchange1031-view',
    templateUrl: './1031-exchange-view.component.html',

})
export class Exchange1031ViewComponent implements OnInit {

    exchange1031Id: string ='';
    trade1031InputModel = {} as Exchange1031ViewModel;
    showEdit = false;
    constructor(private _trade1031Service: Trade1031Service, private activatedRoute: ActivatedRoute, private router: Router,
        private _userManagerService: UserManagerService, public _validationService: ValidationService, private Authentication: AuthenticationService) {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.exchange1031Id = params.id;
        });
       
    }
    selectedExchangeLocation = "";
    LoggedInUser: any;
    isAdmin = false;
    ngOnInit() {

        this._trade1031Service.GetAll1031ExchangeDetails(this.exchange1031Id).subscribe(response => {
            this.trade1031InputModel = response;
            this.LoggedInUser = this.Authentication.user;
            if (this.trade1031InputModel.Status != 'Rejected') {
                this.showEdit = true;
          }
          if (this.Authentication.Admin() || this.Authentication.SuperAdmin()) {
                this.showEdit = false;
                this.isAdmin = true;
            }
            //this.trade1031InputModel.Sold_ProjectedSaleDate = this._validationService.convertUTCDateToLocalDate(this.trade1031InputModel.Sold_ProjectedSaleDate);
            this.selectedExchangeLocation = response["ExchangeStateName"];
            this._userManagerService.getUserDetails(this.trade1031InputModel.Guid).subscribe(response => {
                this.trade1031InputModel.FirstName = response.FirstName;
                this.trade1031InputModel.LastName = response.LastName;
                this.trade1031InputModel.Email = response.Email;
                this.trade1031InputModel.Phone = response.Phoneno;
            });          
        });

    }
    onCancel() {
        this.router.navigate(['/1031-exchanges']);
    }
}
